<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-campanha') }}
                </h1>
            </div>

            <!-- BOTÃO DE SALVAR E CANCELAR -->
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="campanhaSelecionados.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <!-- CAIXA DE BUSCA -->
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-campanha-modal"
                />
            </div>
        </div>

        <!-- LISTAGEM -->
        <div class="registry-wrapper">
            <div v-if="isEmpty">
                <empty-table-message />
                <div style="text-align: center">
                    <span class="message-informacao">{{ $t('msg-aviso-camapanha-produto') }}</span>
                </div>
            </div>
            <b-table
                v-else
                :data="campanha"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="campanhaSelecionados"
                :custom-is-checked="
                    (selecionados, linha) => selecionados.idcampanha === linha.idcampanha
                "
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>

            <!-- PAGINAÇÃO -->
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssCampanhaClienteService from '@/services/vendas/cliente/abas/AssCampanhaClienteService';

// MENSAGENS
import Message from '@/models/Message';

export default {
    props: {
        idCliente: 0,
    },
    data() {
        return {
            service: new AssCampanhaClienteService(this.$http, this.$router),
            campanha: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: 90, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'data-validade', width: 180, sortable: true, sortFn: null },
            ],
            campanhaSelecionados: [],
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],

            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idCliente,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.campanha = value;
                    this.isEmpty = this.campanha.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findNaoAssociados(column, order, page, limit, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findNaoAssociadosVendas(
                    column,
                    order,
                    page,
                    limit,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findNaoAssociadosAgro(
                    column,
                    order,
                    page,
                    limit,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idcliente: this.idCliente,
                    idcampanha: m.idcampanha,
                    codigo: m.idcampanhaerp,
                    descricao: m.descricao,
                    'data-validade': this.$moment(m.datavalidade).format('DD/MM/YYYY'),
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            if (this.campanhaSelecionados.length != 0) {
                this.$root.confirm({
                    message: this.$t('msg-aviso-ordenacao'),
                    onConfirm: (_) => {
                        (this.campanhaSelecionados = []),
                            this.carregarDados(this.pagination.currentPage);
                    },
                    onCancel: (_) => {},
                });
            } else {
                this.carregarDados(this.pagination.currentPage);
            }
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.campanhaSelecionados.length > 0) {
                this.isLoading = true;

                this.saveCampanha()
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-associacao'
                            );
                            this.$emit('fecharModal', true);
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-campanha', true));
                this.isLoading = false;
            }
        },
        saveCampanha() {
            if (this.isVenda) return this.service.saveVendas(this.campanhaSelecionados);
            else return this.service.saveAgro(this.campanhaSelecionados);
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }

    .message-informacao {
        color: #898989;
        width: 50px !important;
        height: 50px !important;
        font-weight: 600;
    }
}
</style>
